import Logger from '../util/Logger';
import _ from 'lodash';

export default {

  /**
   * Get the id
   * @param idea
   * @returns {string} Idea id
   */
  getId (idea) {
    if (!idea) {
      Logger.assert('Must pass an idea object');
    } else {
      const id = _.get(idea, 'id');
      if (!id) {
        Logger.assert('Idea was missing id');
      } else {
        return id;
      }
    }
  },

  /**
   * Get the id
   * @param idea
   * @returns {string} Idea id
   */
  getEventId (idea) {
    if (!idea) {
      Logger.assert('Must pass an idea object');
    } else {
      const id = _.get(idea, 'event_id');
      if (!id) {
        Logger.assert('Idea was missing event_id', this.getId(idea));
      } else {
        return id;
      }
    }
  },

  getName (idea) {
    if (!idea) {
      Logger.assert('Cannot call getName() without an Idea object');
    } else {
      const name = _.get(idea, 'name') || '';
      if (!name) {
        Logger.error('Idea was missing name', this.getId(idea));
        return '';
      } else {
        return name;
      }
    }
  },

  getDescription (idea) {
    if (!idea) {
      Logger.assert('Cannot call getDescription() without an Idea object');
    } else {
      const description = _.get(idea, 'description') || '';
      if (!description) {

        return '';
      } else {
        return description;
      }
    }
  },

  getContent (idea) {
    if (!idea) {
      Logger.assert('Cannot call getContent() without an Idea object');
    } else {
      const content = _.get(idea, 'content') || '';
      if (!content) {
        Logger.error('Idea was missing content', this.getId(idea));
        return '';
      } else {
        return content;
      }
    }
  },

  getLikeCount (idea) {
    if (!idea) {
      Logger.assert('Cannot call getLikeCount() without an Idea object');
    } else {
      return _.get(idea, 'like_count') || 0;
    }
  },

  getDislikeCount (idea) {
    if (!idea) {
      Logger.assert('Cannot call getDislikeCount() without an Idea object');
    } else {
      return _.get(idea, 'dislike_count') || 0;
    }
  },

  getCommentCount (idea) {
    if (!idea) {
      Logger.assert('Cannot call getCommentCount() without an Idea object');
    } else {
      return _.get(idea, 'comment_count') || 0;
    }
  },

  getAvgRating (idea) {
    if (!idea) {
      Logger.assert('Cannot call getAvgRating() without an Idea object');
    } else {
      return _.get(idea, 'avg_rating') || 0;
    }
  },

  getTotalRating (idea) {
    if (!idea) {
      Logger.assert('Cannot call getTotalRating() without an Idea object');
    } else {
      return _.get(idea, 'total_rating') || 0;
    }
  },

  getCreatorInfo (idea) {
    if (!idea) {
      Logger.assert('Cannot call getCreatorInfo() without an Idea object');
    } else {
      const hero = _.get(idea, 'creator_info') || null;
      if (!hero) {
        Logger.error('Idea was missing creator_info', this.getId(idea));
        return null;
      } else {
        return hero;
      }
    }
  },

  getTintColor (idea) {
    if (!idea) {
      Logger.assert('Cannot call getTintColor() without an Idea object');
    } else {
      const color = _.get(idea, 'tint_color') || '';
      if (!color) {
        Logger.error('Idea was missing a tint_color', this.getId(idea));
        return '';
      } else {
        return color;
      }
    }
  },

  getChoiceCount (idea) {
    if (!idea) {
      Logger.assert('Cannot call getChoiceCount() without an Idea object');
    } else {
      return _.get(idea, 'choice_count') || 0;
    }
  },

  getChoiceFrequency (idea) {
    if (!idea) {
      Logger.assert('Cannot call getChoiceFrequency() without an Idea object');
    } else {
      return _.get(idea, 'choice_freq') || 0;
    }
  },

  getChoicePercent (idea) {
    if (!idea) {
      Logger.assert('Cannot call getChoicePercent() without an Idea object');
    } else {
      return _.get(idea, 'choice_pct') || '';
    }
  },

  /**
   * Get the slug if it exists
   * @param idea
   * @returns {string|null} slug or null
   */
  getSlug (idea) {
    if (!idea) {
      Logger.assert('Must pass an idea object');
    } else {
      return _.get(idea, 'slug') || null;
    }
  },

  /**
   * Can this idea be deleted?
   * @param idea
   * @returns {boolean} Can be deleted
   */
  canDelete (idea) {
    if (!idea) {
      Logger.assert('Must pass an idea object');
    } else {
      return _.get(idea, 'can_delete') || false;
    }
  },

  /**
   * Can this idea be archived?
   * @param idea
   * @returns {boolean} Can be archived
   */
  canArchive (idea) {
    if (!idea) {
      Logger.assert('Must pass an idea object');
    } else {
      return _.get(idea, 'can_archive') || false;
    }
  }

};
